import { useState } from "react";
import fr from "../lang/fr.json";
import en from "../lang/en.json";


const useChangeLanguage = () => {
    const [language] = useState(localStorage.getItem("language") || "fr");

    const getArticleTitle = (article) => {
        return language === "fr" ? article.title : article.title_en;
    }

    const getArticleBody = (article) => {
        return language === "fr" ? article.body : article.body_en ;
    }

    const getArticleDescription = (article) => {
        return language === "fr" ? article.description : article.description_en ;
    }   


    const _t = (key) => {
        return language === "fr" ? fr[key] : en[key];
    }
    return {language, getArticleTitle, getArticleBody, getArticleDescription, _t};
}

export default useChangeLanguage
